var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C8 14.55 8.45 15 9 15C9.55 15 10 14.55 10 14C10 13.45 9.55 13 9 13C8.45 13 8 13.45 8 14ZM8 0V4H10V2.08C13.39 2.57 16 5.47 16 9C16 12.87 12.87 16 9 16C5.13 16 2 12.87 2 9C2 7.32 2.59 5.78 3.58 4.58L9 10L10.41 8.59L3.61 1.79V1.81C1.42 3.45 0 6.05 0 9C0 13.97 4.02 18 9 18C13.97 18 18 13.97 18 9C18 4.03 13.97 0 9 0H8ZM15 9C15 8.45 14.55 8 14 8C13.45 8 13 8.45 13 9C13 9.55 13.45 10 14 10C14.55 10 15 9.55 15 9ZM3 9C3 9.55 3.45 10 4 10C4.55 10 5 9.55 5 9C5 8.45 4.55 8 4 8C3.45 8 3 8.45 3 9Z",
    fill: "#585869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertime);
export default __webpack_public_path__ + "static/media/overtime.95efd8d80386ff1fbadec0dd59a5220d.svg";
export { ForwardRef as ReactComponent };